import Vue from 'vue'
import store from '@/common/store'
import components from "./components";
import layout from '@/common/components/layout/layout.js'
import Ajax from '@/common/utils/ajax'
import VeeValidate, { Validator } from 'vee-validate'
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import CzechVeeValidateLocale from 'vee-validate/dist/locale/cs';
import pageLayoutModule from "@/layout/store/pageLayoutModule";
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import { VBScrollspyPlugin, DropdownPlugin, ModalPlugin } from 'bootstrap-vue'
import { EventBus } from '@/common/utils/event-bus'

Validator.localize('cs', CzechVeeValidateLocale);
Vue.use(VeeValidate, { inject: true, fieldsBagName: 'veeFields', locale: 'cs', events: 'input|change|blur|on-close' }); 
Vue.use(ValidationObserver);
Vue.use(ValidationProvider);

Vue.use(VBScrollspyPlugin)
Vue.use(DropdownPlugin)
Vue.use(ModalPlugin)

lazySizes.init();

store.registerModule("pageLayoutModule", pageLayoutModule);
store.commit('pageLayoutModule/SET_PAGE_MODEL', window.pageLayout.model)

components.forEach(({ component, element }) => {

    // Is the custom element in the DOM?
    if (!document.querySelector(element)) {
        return;
    }

    // Create a new Vue instance and mount it to the custom element.
    new Vue({
        store,
        render: createElement => createElement(component)
    }).$mount(element);

});

function mountRegisterForm() {
    return new Vue({
        components: { ValidationObserver, ValidationProvider },
        store,
        methods: {
            validate: function () {
                return this.$refs.observer.validate()
            },
        },
        data() {
            return {
                password: "",
                username: ""
            }
        }
    }).$mount('#v-account-menu');
}

function mountNewsLetterForm() {
    return new Vue({
        components: { ValidationObserver, ValidationProvider },
        store,
        methods: {
            validate() {
                return this.$refs.observer.validate();
            },
        },
        data() {
            return {
                visible: true,
                email: "",
            }
        }
    }).$mount('#v-newsletter');
}

function mountLoader() {
    return new Vue({
        store,
        computed: {
            show() {
                return this.$store.state.isLoading;
            }
        }
    }).$mount('#v-preloader');
}

function registerEventHandlers(){
    EventBus.$on("eshop-cart-item-added", (data) => {
        if(window.gtag){
            let itemData = {
                "item_id": data.productId,
                "item_name": data.name,
                "currency": "CZK",
                "item_brand": data.brand,
                "quantity": data.quantity,
                "price": data.price
            };

            data.category.split(" > ").forEach((element, index) => {
                if(index === 0){
                    itemData["item_category"] = element;   
                } else {
                    let catIndex = index+1;
                    itemData["item_category"+catIndex] = element;
                }
            });
            
            window.gtag('event', 'add_to_cart', {
                "currency": "CZK",
                "value": data.price,
                "items": [
                    itemData
                ]
            });
        }
    });
}

registerEventHandlers();
let vPreloader = mountLoader();
let vRegisterForm = mountRegisterForm();
let vNewsLetterForm = mountNewsLetterForm();

const returnUrlHash = document.getElementsByName('returnUrlHash');
returnUrlHash.value = location.hash;

const loginForm = document.getElementById('loginForm');
const newsletterForm = document.getElementById('newsletterForm');
const resetPasswordForm = document.getElementById('resetPasswordForm');

const mobileBtnSidebarMenu = document.getElementsByClassName('mobile-header__menu-button');
if (mobileBtnSidebarMenu.length > 0) {
    mobileBtnSidebarMenu[0].addEventListener('click', function (e) {
        store.commit("TOGGLE_SIDEBAR_MENU")
    });
}

if (newsletterForm) {
    newsletterForm.addEventListener('submit', function (e) {
        e.preventDefault();
        vNewsLetterForm.validate().then(validationResult => {
            if (!validationResult)
                return;

            Ajax.post(newsletterForm.getAttribute('action'), new FormData(e.target), {
                headers: {
                    contentType: 'application/x-www-form-urlencoded'
                }
            }).then(response => {
                if (response.data.success === true) {
                    vNewsLetterForm.visible = false;
                }
            })
            
        });
    });
}

if (loginForm) {
    loginForm.addEventListener('submit', function (e) {
        e.preventDefault();

        vRegisterForm.validate().then(validationResult => {

            if (!validationResult)
                return;

            Ajax.post(loginForm.getAttribute('action'), new FormData(e.target), {
                headers: {
                    contentType: 'application/x-www-form-urlencoded'
                }
            }).then(response => {
                if (response.data.success === true) {
                    window.location.reload();
                }
            })

        });
    });
}
